<div class="active-results-bar">
    <div class="favourite-tile" [ngClass]="showBanner ? 'transform-fav': 'transform-fav-none'" >
        <div class="results-column">
            <div class="row-fav-tile" [ngClass]="{'row-emt-tile': loadEmptyTile}">
                <ng-container *ngIf="vehicles && !loadEmptyTile ">
                    <an-favorite-tile class="fav-res-tile" [vehicleDetails]="vehicle" [stateData] = "stateData"
                        *ngFor="let vehicle of inStockVehicles; let i = index;"
                        id="vehicle_{{vehicle.Vin}}"></an-favorite-tile>

                </ng-container>
                <ng-container *ngIf="vehicles && !loadEmptyTile && this.isAnyVehicleGone">
                    <an-instigator-tile class="fav-res-tile" id="vehicle_Instiagtor" [stateData] = "stateData" [isInstigator] = "isInstigator" ></an-instigator-tile>

                </ng-container>
                <ng-container *ngIf="vehicles && !loadEmptyTile && vehicles.length === 0 && !this.isAnyVehicleGone">
                    <an-instigator-tile class="fav-res-tile" id="vehicle_Instiagtor" [stateData] = "stateData" [isFav] = "isFav"  [ngClass]="{'fav-veh1-tile': vehicles && !loadEmptyTile && vehicles.length === 0}" ></an-instigator-tile>

                </ng-container>
                <ng-container *ngIf="vehicles && !loadEmptyTile && vehicles.length === 0 && !this.isAnyVehicleGone">
                    <an-placeholder-tile class="fav-res-tile" id="vehicle_placeholder_1" [vehicleCount]=1 [ngClass]="{'fav-veh1-tile': vehicles && !loadEmptyTile && vehicles.length === 0}">

                    </an-placeholder-tile>
                </ng-container>
                <ng-container *ngIf="vehicles  && !loadEmptyTile  && vehicles.length === 0 && !this.isAnyVehicleGone" >
                    <an-placeholder-tile class="fav-res-tile" id="vehicle_placeholder_2" [vehicleCount]=2 [ngClass]="{'fav-veh1-tile': vehicles && !loadEmptyTile && vehicles.length === 0}">

                    </an-placeholder-tile>
                </ng-container>
                <ng-container  *ngIf="loadEmptyTile"  >
                   <div *ngFor="let p of emptyTilesCount()">
                    <an-fav-empty-tile class="fav-res-tile emt-tile"></an-fav-empty-tile>
                   </div>



                </ng-container>
            </div>
            <div class="cta-shop-inventory">
                <p class="text-shop-inv">{{stateData?.NoVehicleTitle}}</p>
                <div class="btn-shop-inv" id="mshopinventory">
                    <a role="button" tabindex="0" class="btn-inventory ada-button-focus" href="/cars-for-sale">{{stateData?.ShopInventoryCta}}</a>
                </div>
            </div>
        </div>
    </div>
</div>
